<template>
	<p>
		<v-btn rounded @click="$emit('save')" color="primary" v-if="status == 'unsaved'">Speichern</v-btn>
		<span v-if="status == 'saving'">Saving...</span>
		<span v-if="status == 'saved'">Saved</span>
		<span class="text--red" v-if="status == 'error'">Something went wrong! Please contact us</span>
	</p>
</template>
<script>
	export default {
		name: "SaveSavingSaved", 
		props: {
			"status": {type: String}
		}
	}
</script>